import * as Scrivito from "scrivito"
import { useScrivitoPage } from "scrivito/hooks/useScrivitoPage"

import { ProjectsOverviewPage } from "pages/projects-overview-page/ProjectsOverviewPage"

import { ProjectsPageObjClass } from "./ProjectsPageObjClass"
import "./styles/_projects-overview-page.scss"

Scrivito.provideComponent(ProjectsPageObjClass, ({ page }) => {
  useScrivitoPage()
  return (
    <div className="projects-overview-page">
      <Scrivito.ContentTag content={page} attribute="breadcrumbWidget" />
      <ProjectsOverviewPage page={page} />
    </div>
  )
})
